const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const compactCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  // Without the minimum, some engines (Node, Chromium) render "$250.0K"
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

/**
 * Postgres numeric columns arrive as strings ("290000.00"). Accepts numbers and
 * numeric strings; anything else (including NaN and Infinity) is null.
 */
export const toNumber = (value: unknown): number | null => {
  const n = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
  return typeof n === "number" && Number.isFinite(n) ? n : null;
};

/** $425,000 — returns an em dash for missing values */
export const formatCurrency = (value: number | string | null | undefined): string => {
  const n = typeof value === "string" ? Number(value) : value;
  return n === null || n === undefined || Number.isNaN(n) ? "—" : currency.format(n);
};

/** $425K / $1.2M for tight spaces like map pins and stat tiles */
export const formatCompactCurrency = (value: number | string | null | undefined): string => {
  const n = typeof value === "string" ? Number(value) : value;
  return n === null || n === undefined || Number.isNaN(n) ? "—" : compactCurrency.format(n);
};

/** SINGLE_FAMILY → Single Family */
export const formatPropertyType = (type: string | null | undefined): string =>
  (type ?? "")
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

/** 1,850 */
export const formatSqft = (sqft: number | null | undefined): string =>
  sqft === null || sqft === undefined ? "—" : new Intl.NumberFormat("en-US").format(sqft);
